let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("gc5di")).then(() => parcelRequire('deeqb'));